import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PillItem } from "../helpers";

import { API, graphqlOperation } from "aws-amplify";
import { onUpdateFlowstop } from "../../graphql/subscriptions-custom";

import { getValveString, getValveSummary } from "../../helpers/Device";
import { nav } from "../../config/navigation";
import i18n from "../../i18n";

const FlowstopItem = ({ flowstopData }) => {
	const [flowstop, setFlowstop] = useState(null);

	const getEffectiveStatus = (state) =>
		state?.valves?.valve1?.status ?? state?.valves?.valve2?.status ?? state?.relay?.status;

	//On Page Load
	useEffect(() => {
		setFlowstop({ ...flowstopData, reported_state: JSON.parse(flowstopData.reported_state) });
		const updateDeviceSubscription = subscribeDeviceState();

		return () => {
			updateDeviceSubscription.unsubscribe();
		};
	}, []);

	const subscribeDeviceState = () => {
		const initialState = JSON.parse(flowstopData.reported_state);
		let compareStatus = getEffectiveStatus(initialState);
		const sub = API.graphql(
			graphqlOperation(onUpdateFlowstop, {
				id: flowstopData.id,
			}),
		).subscribe({
			next: ({ provider, value }) => {
				const updatedState = JSON.parse(value.data.onUpdateDeviceById.reported_state);
				const nextStatus = getEffectiveStatus(updatedState);

				if (compareStatus !== nextStatus) {
					compareStatus = nextStatus;
					setFlowstop({
						...value.data.onUpdateDeviceById,
						reported_state: updatedState,
					});
				}
			},
			error: (error) => console.warn(error),
		});

		return sub;
	};

	//Valve semantics: closed = attention (water off), open = neutral, disabled = grey - matches pills elsewhere
	if (!flowstop) return null;

	const valve = getValveSummary(flowstop?.reported_state);
	const stateLabel = `${getValveString(valve.status)}${
		valve.disabled ? ` (${i18n.t("device.state.disabled")})` : ""
	}`;

	return (
		<Link to={`${nav.device.base}/${flowstop.id}`}>
			<PillItem
				type="full"
				value={`${flowstop.name} - ${stateLabel}`}
				icon="icon-flowstop"
				wrapperStyle={valve.disabled ? "grey" : Boolean(valve.status) ? "error" : "blue1"}
			/>
		</Link>
	);
};

export default FlowstopItem;
